import { render } from "./FirmaCliente.vue?vue&type=template&id=54226232&scoped=true&ts=true"
import script from "./FirmaCliente.vue?vue&type=script&lang=ts"
export * from "./FirmaCliente.vue?vue&type=script&lang=ts"

import "./FirmaCliente.vue?vue&type=style&index=0&id=54226232&scoped=true&lang=css"

import exportComponent from "/Users/michael/Sites/firegui_multilink_app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54226232"]])

export default __exports__